export default __webpack_public_path__ + "4072dd720f1c97708cbff9bb9abf1d46.png";